module.exports = __webpack_public_path__ + "static/media/coach-christian.88fd9fa8.png";